module.exports = __webpack_public_path__ + "static/media/Blood.5b5238a6.png";